module.exports = __webpack_public_path__ + "img/icon-psychologist.ada8935.svg";